import { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';

import { isProd } from 'src/config-global';

// Import only necessary routes for PointPay
import { authRoutes } from './auth';
import { systemRoutes } from './system';
import { publicRoutes } from './public';
import { pointPayRoutes } from './pointpay';

// Import 404 page
const Page404 = lazy(() => import('src/pages/404'));

// Import Payment Link page for non-prod testing
const PaymentLinkPage = lazy(() => import('src/pointpay-public/pages/payment-link'));

// ----------------------------------------------------------------------

export default function RouterPointPay() {
  const routes = [
    {
      path: '/',
      element: <Navigate to="/online-payment" replace />,
    },
    // Auth routes
    ...authRoutes,
    // PointPay specific routes
    ...pointPayRoutes,
    // System, public routes
    ...systemRoutes,
    ...publicRoutes,
    // Payment link route (non-prod only for testing)
    ...(!isProd
      ? [
          {
            path: '/payment-link/:id',
            element: <PaymentLinkPage />,
          },
        ]
      : []),
    // Direct 404 route
    { path: '/404', element: <Page404 /> },
    // No match 404
    { path: '*', element: <Navigate to="/404" replace /> },
  ];

  return useRoutes(routes);
}
